import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { BiLoggerService } from '@core/services/logger/bi-logger.service';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { TlkSlideToggleComponent } from '@itero/ui-toolkit-angular/slide-toggle';
import { DentureDetailsComponent } from '@modules/denture-details/containers/denture-details/denture-details.component';
import { DentureDetailsFacade } from '@modules/denture-details/denture-details.facade';
import { TranslateModule } from '@ngx-translate/core';
import { RxProcedureTypeControlComponent } from '@shared/components/rx-procedure-type-control/rx-procedure-type-control.component';
import { SharedModule } from '@shared/shared.module';

@Component({
	selector: 'rx-intuitive-denture-procedure',
	templateUrl: './rx-intuitive-denture-procedure.component.html',
	styleUrls: ['./rx-intuitive-denture-procedure.component.scss'],
	providers: [DentureDetailsFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TranslateModule,
		SharedModule,
		TlkCardComponent,
		TlkSlideToggleComponent,
		RxProcedureTypeControlComponent
	]
})
export class RxIntuitiveDentureProcedureComponent extends DentureDetailsComponent implements OnInit {
	constructor(formBuilder: FormBuilder, dentureDetailsFacade: DentureDetailsFacade, biLogger: BiLoggerService) {
		super(formBuilder, dentureDetailsFacade, biLogger);
	}

	override ngOnInit(): void {
		super.ngOnInit();
	}

	switchOffControl(event: boolean, control: FormControl): void {
		if (!event && !this.isReadOnly) {
			control.patchValue(false);
		}
	}
}
